import {BreadcrumbType} from 'platform/components';

import i18n from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {TeamForm} from '../../components/TeamForm/TeamForm';

const breadcrumbs: BreadcrumbType[] = [
  {
    label: i18n.t('page.settings.labels.teamManagement'),
    href: settingsRoutes.teamManagement,
  },
];

export function AddTeam() {
  return (
    <SettingsTemplate
      header={{
        breadcrumbs,
        title: i18n.t('page.settings.labels.newWorkTeam'),
      }}
      headerVariant="v2"
      data-testid={testIds.settings.teamManagementAddTeam('page')}
      isCreating
      tabs={[
        {
          queryId: 'general',
          title: i18n.t('general.labels.general'),
          content: <TeamForm />,
        },
        {
          queryId: 'members',
          title: i18n.t('general.labels.teamMembers'),
          content: <></>,
          isDisabled: true,
        },
      ]}
    />
  );
}
